import "./remainingAmount.scss";

interface RemainingAmountProps {
    amount: number;
    paidAmount: number;
}

function getModifier(amount: number, paidAmount: number): string {
    const remaining = amount - paidAmount;
    if (paidAmount === 0) return "grey";
    if (remaining / amount > 0.75) return "red";
    if (remaining / amount > 0.4) return "orange";
    if (remaining / amount > 0.2) return "blue";
    if (remaining <= 2) return "green";
    return "grey";
}

export default function RemainingAmount({
    amount,
    paidAmount,
}: RemainingAmountProps) {
    const remaining = amount - paidAmount;
    const modifier = getModifier(amount, paidAmount);
    return (
        <span className={`remaining-amount remaining-amount--${modifier}`}>
            €{remaining.toFixed(2)}
        </span>
    );
}
